import React, { useCallback, useMemo, useState } from 'react';
import { EntityStatus, IItemForGetShortInfoWithStatus } from 'types';
import { SHOW_ARCHIVED_CUSTOMERS, SHOW_ARCHIVED_RESTAURANTS } from 'appConstants';
import { ISelectOption } from 'components/Select/types';
import { ArchivedLabel } from 'components/Select/ArchivedLabel';

interface IUseArchivedMultiSelectParams {
	items: IItemForGetShortInfoWithStatus[];
	entityType: 'restaurants' | 'customers';
	selectedIds: string[];
}

export const useArchivedMultiSelect = ({ items, entityType, selectedIds }: IUseArchivedMultiSelectParams) => {
	const storageKey = entityType === 'restaurants' ? SHOW_ARCHIVED_RESTAURANTS : SHOW_ARCHIVED_CUSTOMERS;
	const [showArchived, setShowArchived] = useState<boolean>(localStorage.getItem(storageKey) === 'true');

	const toggleShowArchived = useCallback(() => {
		localStorage.setItem(storageKey, JSON.stringify(!showArchived));
		setShowArchived((prevValue) => !prevValue);
	}, [showArchived, storageKey]);

	const visibleItems = useMemo(() => {
		return showArchived
			? items
			: items.filter((item) => item.status === EntityStatus.Active || selectedIds.includes(item.id));
	}, [items, showArchived, selectedIds]);

	const options = useMemo<ISelectOption[]>(() => {
		return visibleItems.map((item) => ({
			...item,
			additionalContent: item.status === EntityStatus.Archived ? <ArchivedLabel /> : undefined,
		}));
	}, [visibleItems]);

	return { showArchived, toggleShowArchived, visibleItems, options };
};
